export interface IIntegration {
  name: string;
  image: string;
}

export const Integrations: IIntegration[] = [
  {
    name: 'wordpress',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24050512403889_WordPress.svg',
  },
  {
    name: 'shopify',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24050512403827_Shopify.svg',
  },
  {
    name: 'wix',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24050512403833_WIX.svg',
  },
  {
    name: 'squarespace',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24051910363068_squarespace.svg',
  },
  {
    name: 'reactJS',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24050512403845_Reacts.svg',
  },
  {
    name: 'angular',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24050512403852_Angular.svg',
  },
  {
    name: 'html',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24062311343756_Html_square.svg',
  },
  {
    name: 'bubble',
    image: 'https://cdn.1cdn.app/application/LOUISEBOT/24073012280095_Bubble.svg',
  },
];
